import axiosInstance from "./api";

const TEST_CONFIG_API = "/api/test-config";

export const createTestConfig = async (topic_key, data) => {
  try {
    const result = await axiosInstance.post(
      `${TEST_CONFIG_API}/${topic_key}`,
      data
    );
    if (result.data?.error) {
      throw new Error(result.data.error);
    }
    return result.data.data;
  } catch (error) {
    console.error("Error creating test config:", error);
    throw error;
  }
};

export const getTestConfigById = async (id) => {
  try {
    const result = await axiosInstance.get(`${TEST_CONFIG_API}/${id}`);
    return result.data.data;
  } catch (error) {
    console.error("Error fetching test config by ID:", error);
    throw error;
  }
};

export const updateTestConfig = async ({ id, data }) => {
  try {
    const result = await axiosInstance.put(
      `${TEST_CONFIG_API}/${id}/update`,
      data
    );
    if (result.data?.error) {
      throw new Error(result.data.error);
    }
    return result.data.data;
  } catch (error) {
    console.error("Error updating test config:", error);
    throw error;
  }
};

export const getTestConfigsByTopicKey = async (topic_key) => {
  try {
    const result = await axiosInstance.get(
      `${TEST_CONFIG_API}/topic/${topic_key}`
    );
    return result.data.data;
  } catch (error) {
    console.error("Error fetching test configs by topic key:", error);
    throw error;
  }
};

export default {
  createTestConfig,
  getTestConfigById,
  updateTestConfig,
  getTestConfigsByTopicKey,
};
